import { DateValue } from '@internationalized/date';

import { parseInterval, subtractIntervalFromDate } from './parseInterval';
import { RangeValue, TimeOption, TimeRange } from '../types';

export function createTimeRangeFromOption(
  optionValue: string,
  option: TimeOption | undefined
): TimeRange {
  const now = new Date();
  const interval = parseInterval(optionValue);
  const dateFrom = subtractIntervalFromDate(now, interval);

  return {
    interval: optionValue,
    name: optionValue,
    label: typeof option?.label === 'string' ? option.label : optionValue,
    dateFrom: dateFrom.toISOString(),
    dateTo: now.toISOString()
  };
}

export function createTimeRangeFromDateRange(
  range: RangeValue<DateValue>
): TimeRange {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    interval: 'custom',
    name: 'custom-range',
    label: 'Custom',
    dateFrom: range.start.toDate(timezone).toISOString(),
    dateTo: range.end.toDate(timezone).toISOString()
  };
}
